const subscriptionTypes = {
    UPDATE_CURRENT_SERVICE:'UPDATE_CURRENT_SERVICE',
    UPDATE_CURRENT_SPORT:'UPDATE_CURRENT_SPORT',
    UPDATE_SUBSCRIBED_SERVICES:'UPDATE_SUBSCRIBED_SERVICES',
}

export default subscriptionTypes